import React, { useState } from "react";
import "./Compliances_Remainder.scss";
import Compliances_header from "./Compliances_header";
import Compliances_data from "./Compliances_data";
import Compliances_Footer from "./Compliances_Footer";

const Compliances_Remainder = () => {
  const [showCompleted, setShowCompleted] = useState(false);
  const handleDoeClick = () => {
    setShowCompleted((prev) => !prev);
  };
  return (
    <div className="Compliances_Remainder_main_Container">
      <Compliances_header />
      <Compliances_data showCompleted={showCompleted} />
      <Compliances_Footer handleDoeClick={handleDoeClick} />
    </div>
  );
};

export default Compliances_Remainder;
